import script from "./Language.vue?vue&type=script&setup=true&lang=ts"
export * from "./Language.vue?vue&type=script&setup=true&lang=ts"

import "./Language.vue?vue&type=style&index=0&id=556aaa50&lang=css"

const __exports__ = script;

export default __exports__